
import "../Auth.less";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { useAuth } from "../../../hooks/auth/AuthContext";
import { useEffect } from "react";

interface Props {
    backToFirstPage: () => void;
}

const RegisterStep3 = ({ backToFirstPage }: Props) => {
    const navigate = useNavigate();
    const { authState } = useAuth();

    const goHomePage = () => {
        navigate('/home');
    }

    return (
        <>
            <div className="register-form-title"><FormattedMessage id={'AUTH_REGISTER_STEP3'} /></div>
            <div className="register-form-item">
                <FormattedMessage id={'AUTH_REGISTER_SUCCESS'} />
            </div>
            <Button block type="primary" htmlType="submit" className="register-deposit-btn" onClick={goHomePage} >
                <FormattedMessage id={'AUTH_REGISTER_BACK_FIRST'} />
            </Button>
        </>
    );
};

export default RegisterStep3;
